import { render, staticRenderFns } from "./openBusinessProcessSetting.vue?vue&type=template&id=282ba78d&scoped=true"
import script from "./openBusinessProcessSetting.vue?vue&type=script&lang=ts"
export * from "./openBusinessProcessSetting.vue?vue&type=script&lang=ts"
import style0 from "./openBusinessProcessSetting.vue?vue&type=style&index=0&id=282ba78d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ba78d",
  null
  
)

export default component.exports